<template>
    <div>
        <div class="row">
            <div class="col-md-3">
                <section class="card card-featured-left card-featured-primary mb-3">
                    <div class="card-body">
                        <div class="widget-summary widget-summary-md">
                            <div class="widget-summary-col widget-summary-col-icon">
                                <div class="summary-icon text-secondary">
                                    <div class="progress1 mx-auto">
                    <span class="progress1-left">
                      <span class="progress1-bar border-primary" :style="discLeftStyle"></span>
                    </span>
                                        <span class="progress1-right">
                      <span class="progress1-bar border-primary" :style="discRightStyle"></span>
                    </span>
                                        <div class="progress1-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center">
                                            <div class="font-weight-bold">{{ discText }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-summary-col">
                                <div class="summary">
                                    <div class="info">
                                        <strong class="amount">Disco Duro</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <div id="client-list"
             class="card">
            <div class="card-header bg-info">Listado de Sistemas de Clientes</div>
            <div class="card-body">
                <div class="row">

                    <div class="col">
                        <button
                            v-if="addClientsSystem"
                            class="btn btn-custom btn-sm mt-2 mr-2 mb-3"
                            type="button"
                            @click.prevent="clickCreate()"
                        >
                            <i class="fa fa-plus-circle"></i> Nuevo
                        </button>
                        <el-button v-if="showExcel"
                            size="small"
                            type="success"
                            @click.prevent="exportClientExcel()"
                            :loading="loadingExcel"
                        >
                            <i class="fa fa-file-excel"></i> Exportar Excel
                        </el-button>
                    </div>

                    <div class="col text-right">
                        <div class="d-flex" style="gap: 8px;">
                            <div style="width: fit-content;">
                                Activar masivamente:
                            </div>

                            <div class="text-center">
                                <el-button
                                    size="small"
                                    type="primary"
                                    @click.prevent="changeLockedEmissionMassive()"
                                >
                                    Limitar Doc.
                                </el-button>
                            </div>

                            <div class="text-center">
                                <el-button
                                    size="small"
                                    type="primary"
                                    @click.prevent="changeLockedUserMassive()"
                                >
                                    Limitar Usuarios
                                </el-button>
                            </div>

                            <div class="text-center">
                                <el-button
                                    size="small"
                                    type="primary"
                                    @click.prevent="changeLockedEstablishmentsMassive()"
                                >
                                    Limitar Establecimientos
                                </el-button>
                            </div>
                                
                            <div class="text-center">
                                <el-button
                                    size="small"
                                    type="primary"
                                    @click.prevent="changeLockedSalesMassive()"
                                >
                                    Limitar Ventas (Mes)
                                </el-button>
                            </div>
                        </div>
                    </div>

                </div>

                
                <div class="row">
                    <div class="col-12 col-lg-3 pt-2 pb-2">
                        <div class="d-flex">
                            <div style="width:100px">
                                Filtrar por:
                            </div>
                            
                            <el-select
                                v-model="search.column"
                                placeholder="Seleccionar"
                                @change="changeClearInput"
                            >
                                <el-option
                                    v-for="item in listOptionSearch"
                                    :key="item.id"
                                    :value="item.id"
                                    :label="item.text"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>

                    <div class="col-12 col-lg-5 pt-2 pb-2">
                        <div class="form-group">
                            <div class="input-group">
                                <el-input
                                    v-model="search.value"
                                    prefix-icon="el-icon-search"
                                    placeholder="Buscar..."
                                    style="height: 100%;"
                                ></el-input>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4 pt-2 pb-2">
                        <div class="d-flex">
                            <div style="width:100px">
                                Partner PSE:
                            </div>
                            
                            <el-select
                                v-model="partnerPSE_selected"
                                placeholder="Seleccionar"
                            >
                                <el-option
                                    v-for="item in listPartnerPSE"
                                    :key="item.id"
                                    :value="item.id"
                                    :label="item.text"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>
                    
                    <div class="col-12 col-lg-5 pt-2 pb-2">
                        <div class="d-flex items-center">
                            <div style="width:235px">
                                Sistemas de clientes:
                            </div>
                            
                            <el-select
                                v-model="statusClient"
                                placeholder="Seleccionar"
                                @change="systemClients"
                            >
                                <el-option
                                    v-for="item in listStatusClient"
                                    :key="item.id"
                                    :value="item.id"
                                    :label="item.text"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>

                    <div class="col-12 col-lg-7 pt-2 pb-2">
                        <div class="d-flex" style="justify-content: space-between;">
                            <div class="form-group">
                                <label class="control-label">Filtrar por PSE</label>
                                <el-checkbox 
                                    v-model="use_PSE"
                                    @change="filterPSE"
                                ></el-checkbox>
                            </div>
    
                            <div class="form-group" style="margin-left: 5px !important;">
                                <label class="control-label">Filtrar por OSE</label>
                                <el-checkbox 
                                    v-model="use_OSE"
                                    @change="filterOSE"
                                ></el-checkbox>
                            </div>

                            <div class="form-group" style="margin-left: 5px !important;">
                                <label class="control-label">Filtrar por SUNAT</label>
                                <el-checkbox 
                                    v-model="use_SUNAT"
                                    @change="filterSUNAT"
                                ></el-checkbox>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-lg-5 pb-2">
                        <div class="form-group">
                            <label class="control-label">
                                Creador del sistema
                            </label>
                            <el-select v-model="created_by" placeholder="Seleccionar"
                                @change="getData"
                                style="width: 370px;"
                            >
                                <el-option v-for="(item, index) in listCreated_by"
                                    :key="index"
                                    :value="item.id"
                                    :label="item.text"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>

                    <div class="col-12 col-lg-4 pb-2">
                        <div class="form-group">
                            <label class="control-label">
                                Vendedor
                            </label>
                            <el-select v-model="seller_id" placeholder="Seleccionar"
                                @change="getData"
                                style="width: 330px;"
                            >
                                <el-option v-for="(item, index) in listSellers"
                                    :key="index"
                                    :value="item.id"
                                    :label="item.text"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>

                    <div class="col-12 col-lg-3 pb-2">
                        <div class="form-group">
                            <label class="control-label">
                                Filtrar por Falta terminar de configurar
                                <el-checkbox
                                    v-model="configuration_missing_data"
                                    @change="getData"
                                ></el-checkbox>
                            </label>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-12 col-sm-12 pt-2 pb-2">
                        <div class="d-flex">
                            <div style="width:100px">
                                Ordenar por:
                            </div>
                            
                            <el-cascader
                                v-model="orderBy"
                                :options="listOptionOrderBy"
                                :props="cascaderProps"
                                @change="handleChange"
                            >
                                <template slot-scope="{ node, data }">
                                    <div class="cascader-row">
                                    <!-- Texto por defecto de cada opción -->
                                    <span class="title">{{ data.label }}</span>

                                    <!-- Nietos de certificate_due: red/yellow/green/all -->
                                    <template v-if="node.level === 3 && ['red','yellow','green'].includes(data.value)">
                                        <span
                                        v-if="['red','yellow','green'].includes(data.value)"
                                        class="dot"
                                        :class="'dot--'+data.value"
                                        />
                                        <!-- <small class="hint" v-if="hints[data.value]">{{ hints[data.value] }}</small> -->
                                        <el-tooltip :content="hints[data.value]"
                                            placement="top"
                                        >
                                            <i class="fa fa-info-circle"></i>
                                        </el-tooltip>
                                    </template>

                                    <!-- Opción especial en nivel 2 -->
                                    <template v-else-if="node.level === 2 && data.value === 'empty'">
                                        <!-- <i class="el-icon-warning-outline" />
                                        <small class="hint">Sin fecha registrada</small> -->
                                    </template>

                                    <!-- Ejemplo: si alguna opción trae un conteo -->
                                    <el-tag v-if="typeof data.count === 'number'" size="mini" effect="plain" class="ml-2">
                                        {{ data.count }}
                                    </el-tag>
                                    </div>
                                </template>
                            </el-cascader>
                        </div>
                    </div>

                    <div class="col-lg-2 col-md-12 col-sm-12 pt-2 pb-2">
                        <div class="form-group" style="margin-left: 5px !important;">
                            <label class="control-label">Envío con GIOR</label>
                            <el-checkbox 
                                v-model="send_gior_as_ose"
                                @change="sendGior"
                            ></el-checkbox>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-12 col-sm-12 pt-2 pb-2">
                        <div class="d-flex">
                            <div style="width:100px">
                                Filtrar por Notificaciones:
                            </div>
                            
                            <!-- <el-select
                                v-model="filterByhNotifications"
                                placeholder="Seleccionar"
                            >
                                <el-option
                                    v-for="item in listOptionSearchNotifications"
                                    :key="item.id"
                                    :value="item.id"
                                    :label="item.text"
                                ></el-option>
                            </el-select> -->

                            <el-cascader v-model="filterByhNotifications"
                                :options="listOptionSearchNotifications"
                                popper-class="cascader-notifications"
                            >
                                <template slot-scope="{ node, data }">
                                    <div class="cascader-row">
                                        <span>{{ data.label }}</span>
                                        <template v-if="data.value === '4'">
                                            <el-tooltip content="Comprobantes rechazados en el mes actual" 
                                                placement="top"
                                                effect="dark"
                                            >
                                                <i class="fa fa-info-circle"></i>
                                            </el-tooltip>
                                        </template>
                                        <template v-if="data.value === '5'">
                                            <el-tooltip content="Cantidad de rechazados que no han sido verificados (todo el historial)" 
                                                placement="top"
                                                effect="dark"
                                            >
                                                <i class="fa fa-info-circle"></i>
                                            </el-tooltip>
                                        </template>

                                        <template v-if="node.level === 2 && ['lte_5', 'lte_10', 'gt_10'].includes(data.value)">
                                            <el-tooltip :content="hintsNotifications[data.value]"
                                                placement="top"
                                                effect="dark"
                                            >
                                                <i class="fa fa-info-circle"></i>
                                            </el-tooltip>
                                        </template>
                                    </div>
                                </template>
                            </el-cascader>
                        </div>
                    </div>

                    <div class="col">
                        <button
                            class="btn btn-custom btn-sm mt-2 mr-2 mb-3"
                            type="button"
                            @click.prevent="clickSearch()"
                        >
                            Buscar
                        </button>
                    </div>


                    <div class="col-12">
                        <el-collapse v-model="showMoreFilters" @change="changeShowMoreFilters()">
                            <el-collapse-item :title="titleCollapse" name="1">
                                <div class="row">
                                    <div class="col">
                                        Filtrar por límite Documentos
                                        <div>
                                            <el-checkbox
                                                style="display: block;"
                                                v-model="morefilters.limit_doc_active"
                                                @change="changeLimitDocumentsActive"
                                            >
                                                Activado
                                            </el-checkbox>
                                            <el-checkbox
                                                style="display: block;"
                                                v-model="morefilters.limit_doc_disabled"
                                                @change="changeLimitDocumentsDisabled"
                                            >
                                                Desactivado
                                            </el-checkbox>
                                        </div>
                                    </div>

                                    <div class="col">
                                        Filtrar por límite usuarios
                                        <div>
                                            <el-checkbox
                                                style="display: block;"
                                                v-model="morefilters.limit_users_active"
                                                @change="changeLimitUsersActive"
                                            >
                                                Activado
                                            </el-checkbox>
                                            <el-checkbox
                                                style="display: block;"
                                                v-model="morefilters.limit_users_disabled"
                                                @change="changeLimitUsersDisabled"
                                            >
                                                Desactivado
                                            </el-checkbox>
                                        </div>
                                    </div>

                                    <div class="col">
                                        Filtrar por límite establecimiento
                                        <div>
                                            <el-checkbox
                                                style="display: block;"
                                                v-model="morefilters.limit_establishment_active"
                                                @change="changeLimitEstablishmentActive"
                                            >
                                                Activado
                                            </el-checkbox>
                                            <el-checkbox
                                                style="display: block;"
                                                v-model="morefilters.limit_establishment_disabled"
                                                @change="changeLimitEstablishmentDisabled"
                                            >
                                                Desactivado
                                            </el-checkbox>
                                        </div>
                                    </div>

                                    <div class="col">
                                        Filtrar por límite ventas
                                        <div>
                                            <el-checkbox
                                                style="display: block;"
                                                v-model="morefilters.limit_sales_active"
                                                @change="changeLimitSalesActive"
                                            >
                                                Activado
                                            </el-checkbox>
                                            <el-checkbox
                                                style="display: block;"
                                                v-model="morefilters.limit_sales_disabled"
                                                @change="changeLimitSalesDisabled"
                                            >
                                                Desactivado
                                            </el-checkbox>
                                        </div>
                                    </div>

                                    <div class="col-12 pt-2">
                                        <el-button
                                            type="primary"
                                            size="small"
                                            @click.prevent="resetMoreFilter()"
                                        >Borrar filtros</el-button>
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </div>

                <div v-if="lockUnlockClientsSystem"
                    class="row mt-2"
                >
                    <div class="col-12">
                        <el-button type="success"
                            @click.prevent="showDialogLockOrUnlock = true"
                        >
                            Bloquear/Desbloquear masivamente
                        </el-button>
                    </div>
                </div>

                <div class="table-responsive" v-loading="loading">
                    <table class="table">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Hostname</th>
                            <th>Nombre</th>
                            <th>RUC</th>
                            <th>Plan</th>
                            <th>Correo</th>
                            <th>Entorno</th>
                            <th class="text-center">Total de Comprobantes</th>


                            <th class="text-center">
                                OSE
                            </th>
                            <th class="text-center">
                                PSE
                            </th>
                            <th class="text-center">Fecha vencimiento certificado</th>

                            <th>Partner PSE</th>

                            <th class="text-center">Notificaciones</th>
                            <th class="text-center">F.Creación</th>
                            
                            <th class="text-right text-nowrap">Inicio del Ciclo de límites</th>
                            <th class="text-right text-nowrap">Inicio del Ciclo de pago</th>
                            <th class="text-center">Periodo</th>
                            <th class="text-center">Usuarios</th>

                            <th class="text-center">Establecimientos</th>
                            
                            <th class="text-center">Comprobantes Ciclo Facturacion
                                <br>(Mes)
                                <el-tooltip class="item"
                                            content="Cantidad"
                                            effect="dark"
                                            placement="top">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </th>
                            <th class="text-center">Ventas (Mes)
                                <el-tooltip class="item"
                                            content="Monto S/."
                                            effect="dark"
                                            placement="top">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </th>
                            <th class="text-center">Cant.Total<br><small>(Comprobantes por mes)</small>
                                <el-tooltip class="item"
                                            content="Cantidad"
                                            effect="dark"
                                            placement="top">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </th>
                            <th class="text-center">Cant.Notas de venta por mes
                                <el-tooltip class="item"
                                            content="Cantidad"
                                            effect="dark"
                                            placement="top">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </th>
                            
                            
                            <th class="text-center">Cant.Total<br><small>(Comprobantes + <br>notas de venta <br>por mes)</small>
                                <el-tooltip class="item"
                                            content="Cantidad"
                                            effect="dark"
                                            placement="top">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </th>
                            
                            <th class="text-center">Consultas <br>API Peru <br>(mes)</th>
                            <th class="text-center">Total<br><small>(Comprobantes a PSE-GIOR)</small></th>
                            <th class="text-center">Bloquear cuenta</th>

                            
                            <th class="text-center">Limitar Usuarios</th>

                            <th class="text-center">Limitar Establecimientos</th>

                            <th class="text-right">Limitar Doc. <br>(Mes)
                                <el-tooltip class="item"
                                            content="Cantidad"
                                            effect="dark"
                                            placement="top">
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </th>
                            <th class="text-center">
                                <label>Limitar Ventas (Mes)
                                    <el-tooltip class="item"
                                                content="Límite de ventas mensual asociado al ciclo de facturación, Monto S/."
                                                effect="dark"
                                                placement="top">
                                        <i class="fa fa-info-circle"></i>
                                    </el-tooltip>
                                </label>
                            </th>


                            <th class="text-right">Acciones</th>
                            <!-- <th class="text-right">Pagos</th>
                            <th class="text-right">E. Cuenta</th>
                            <th class="text-right">Editar</th> -->
                        </tr>
                        </thead>
                        <tbody>

                        <template v-if="!pagination.total">
                            <tr>
                                <td colspan="28"
                                    class="text-center">
                                    Sin resultados
                                </td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr v-for="(row, index) in records"
                                :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>
                                    <!-- {{ row.hostname }} -->
                                    <a :href="`http://${row.hostname}`"
                                       style="color:black"
                                       target="_blank">{{ row.hostname }}</a>
                                </td>
                                <td>{{ row.name }}</td>
                                <td>{{ row.number }}</td>
                                <td>{{ row.plan }}</td>
                                <td>{{ row.email }}</td>
                                <td>
                                    <span v-if="row.soap_type == '01'"
                                          class="badge badge-default">Demo</span>
                                    <span v-if="row.soap_type == '02'"
                                          class="badge badge-success">Producción</span>
                                    <span v-if="row.soap_type == '03'"
                                          class="badge badge-info">Interno</span>
                                </td>
                                <td class="text-center">
                                    <label>
                                        <strong>{{ row.count_doc }}</strong>
                                    </label>
                                </td>
    
    
                                <td class="text-center">
                                    <el-checkbox :value="row.use_OSE == '1' ? true : false" class="custom-checkbox"></el-checkbox>
                                </td>
                                <td class="text-center">
                                    <el-checkbox :value="row.use_PSE == '1' ? true : false" class="custom-checkbox"></el-checkbox>
                                </td>
                                <td class="text-center"
                                    :class="checkDateDue(row.certificate_due)"
                                >
                                    {{ row.certificate_due }}
                                </td>
    
                                <td class="text-center">
                                    {{ partnerPSE(row.pse_provider_id) }}
                                </td>
    
    
                                <td class="text-center">
    
                                    <el-tooltip class="item"
                                                content="Comprobantes enviados / por enviar"
                                                effect="dark"
                                                placement="top-start">
                                        <el-badge :value="row.document_not_sent"
                                                  class="item"
                                                  :type="row.document_not_sent == 0 ? 'primary' : 'danger'">
                                            <i class="far fa-bell text-secondary"></i>
                                        </el-badge>
                                    </el-tooltip>
    
                                    <el-tooltip class="item"
                                                content="Comprobantes pendientes de rectificación"
                                                effect="dark"
                                                placement="top-start">
                                        <el-badge :value="row.document_regularize_shipping"
                                                  class="item  ml-4"
                                                  :type="row.document_regularize_shipping == 0 ? 'primary' : 'danger'">
                                            <i class="fas fa-exclamation-triangle text-secondary"></i>
                                        </el-badge>
                                    </el-tooltip>

                                    <br>
                                    <el-tooltip class="item"
                                        content="Comprobantes rechazados en el mes actual"
                                        effect="dark"
                                        placement="top-start"
                                    >
                                        <el-badge :value="row.document_rejected" class="item"
                                            :type="typeNotificationDocumentReject(row.document_rejected)"
                                        >
                                            <i class="fas fa-archive"></i>
                                        </el-badge>
                                    </el-tooltip>
                                    <!-- Aplica para todo el historial de comprobantes, no solo para el mes actual   -->
                                    <el-tooltip class="item"
                                        content="Cantidad de rechazados que no han sido verificados"
                                        effect="dark"
                                        placement="top-start"
                                    >
                                        <el-badge :value="row.document_rejected_not_verified" class="item ml-4"
                                            :type="typeNotificationDocumentReject(row.document_rejected_not_verified)"
                                        >
                                            <i class="fas fa-clipboard-list text-secondary"></i>
                                        </el-badge>
                                    </el-tooltip>

    
                                    <el-tooltip class="item"
                                                content="Comprobantes por anular"
                                                effect="dark"
                                                placement="top-start">
                                        <el-badge :value="row.document_to_be_canceled"
                                                  class="item  ml-4"
                                                  :type="row.document_to_be_canceled == 0 ? 'primary' : 'danger'">
                                            <i class="fas fa-exclamation-circle text-secondary"></i>
                                        </el-badge>
                                    </el-tooltip>
    
                                </td>
                                <td class="text-center">{{ row.created_at }}</td>
                                <!--Inicio de ciclo de limites-->
                                <td class="text-end">
                                    <template v-if="row.start_billing_cycle">
                                        <el-button v-if="EditBillingCycle" @click="row.change_billing_cycle = !row.change_billing_cycle" type="primary" size="small" round mini style="padding: 6px;" icon="el-icon-edit"></el-button>
                                        {{ row.start_billing_cycle }}

                                    </template>
                                    <template v-if="!row.start_billing_cycle || row.change_billing_cycle">
                                        <el-date-picker
                                            v-model="row.select_date_billing"
                                            placeholder="..."
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            @change="setStartBillingCycle($event, row.id)"
                                        ></el-date-picker>
                                    </template>
                                </td>
                                <!--Inicio de ciclo de pagos-->
                                <td class="text-end">
                                    <template v-if="row.start_payment_cycle">
                                        <el-button v-if="EditPaymentCycle" @click="row.change_payment_cycle = !row.change_payment_cycle" type="primary" size="small" round mini style="padding: 6px;" icon="el-icon-edit"></el-button>
                                        {{ row.start_payment_cycle }}

                                    </template>
                                    <template v-if="!row.start_payment_cycle || row.change_payment_cycle">
                                        <el-date-picker
                                            v-model="row.select_date_payment"
                                            placeholder="..."
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                            @change="setStartPaymentCycle($event, row.id)"
                                        ></el-date-picker>
                                    </template>
                                </td>
    
                                <td class="text-center">    
                                    {{row.period_name ? row.period_name : ''}}
                                </td>
    
                                <td class="text-center">
                                    <template v-if="row.max_users !== 0 && row.count_user > row.max_users">
                                        <el-popover
                                            :content="text_limit_users"
                                            placement="top-start"
                                            trigger="hover"
                                            width="220"
                                        >
                                            <label slot="reference"
                                                   class="text-danger">
                                                <strong>{{ row.count_user }}</strong>
                                            </label>
                                        </el-popover>
                                    </template>
                                    <template v-else>
                                        <label>
                                            <strong>{{ row.count_user }}</strong>
                                        </label>
                                    </template>
                                    /
                                    <template v-if="row.max_users == 0">
                                        <i class="fas fa-infinity"></i>
                                    </template>
                                    <template v-else>
                                        <strong>{{ row.max_users }}</strong>
                                    </template>
                                </td>
    
                                <td class="text-center">
    
                                    <data-limit-notification
                                        entity_description="establecimientos"
                                        :unlimited="row.establishments_unlimited"
                                        :quantity="row.quantity_establishments"
                                        :max_quantity="row.max_quantity_establishments"
                                        >
                                    </data-limit-notification>
    
                                </td>

                                <td class="text-center">
                                    <strong>
                                        <template v-if="row.sale_notes_quantity_if_include > 0">
                                            <!-- {{ row.count_doc_month ? (row.count_doc_month + row.sale_notes_quantity_if_include) : 0 }} / -->
                                            <template v-if="row.count_doc_month + row.sale_notes_quantity_if_include">
                                                <template v-if="row.max_documents && row.count_doc_month + row.sale_notes_quantity_if_include > row.max_documents">
                                                    <el-popover placement="top"
                                                        trigger="hover"
                                                        content="El límite de documentos por mes fue superado"
                                                    >
                                                        <label slot="reference" class="text-danger">
                                                            <strong>{{ row.count_doc_month + row.sale_notes_quantity_if_include }}</strong>
                                                        </label>
                                                    </el-popover>
                                                </template>
                                                <template v-else>
                                                    <strong>{{ row.count_doc_month + row.sale_notes_quantity_if_include }}</strong>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <strong>0</strong>
                                            </template>
                                            <strong> /</strong>
                                        </template>
                                        <template v-else>
                                            <!-- {{ row.count_doc_month ? row.count_doc_month : 0 }} / -->
                                            <template v-if="row.count_doc_month">
                                                <template v-if="row.max_documents && row.count_doc_month > row.max_documents">
                                                    <el-popover placement="top"
                                                        trigger="hover"
                                                        content="El límite de documentos por mes fue superado"
                                                    >
                                                        <label slot="reference" class="text-danger">
                                                            <strong>{{ row.count_doc_month }} /</strong>
                                                        </label>
                                                    </el-popover>
                                                </template>
                                                <template v-else>
                                                    <strong>{{ row.count_doc_month }} /</strong>
                                                </template>
                                            </template>
                                            <template v-else>
                                                0 /
                                            </template>
                                        </template>
    
                                        <template v-if="row.max_documents == 0">
                                            <i class="fas fa-infinity"></i>
                                        </template>
                                        <template v-else>
                                            <strong>{{ row.max_documents }}</strong>
                                        </template>
                                    </strong>

                                    <el-tooltip :content="messageInfo('quantity', row.include_sale_notes_limit_documents)"
                                        placement="top"
                                    >
                                        <i class="fa fa-info-circle"></i>
                                    </el-tooltip>
                                </td>
    
                                <td class="text-center">
    
                                    <data-limit-notification
                                        entity_description="ventas"
                                        style_div="width: 150px !important"
                                        :unlimited="row.sales_unlimited"
                                        :quantity="row.monthly_sales_total"
                                        :max_quantity="row.max_sales_limit"
                                        >
                                    </data-limit-notification>
    
                                    <el-tooltip :content="messageInfo('amount', row.include_sale_notes_sales_limit)"
                                        placement="top"
                                    >
                                        <i class="fa fa-info-circle"></i>
                                    </el-tooltip>
                                </td>
    
                                <td class="text-center"><strong>{{ row.current_count_doc_month }}</strong></td>
                                <td class="text-center"><strong>{{ row.count_sales_notes }}</strong></td>
                                
                                <td class="text-center"><strong>{{ row.count_doc_month + row.count_sales_notes_month }}</strong></td>
    
                                <td>{{ row.queries_to_apiperu }}</td>
                                <td class="text-center"><strong>{{ row.count_doc_pse }}</strong></td>
                                <td class="text-center">
                                    <template v-if="!row.locked">
                                        <el-switch
                                            v-model="row.locked_tenant"
                                            style="display: block"
                                            @change="changeLockedTenant(row)"
                                        ></el-switch>
                                    </template>
                                </td>
    
                                
    
                                <td class="text-center">
                                    <el-switch
                                        v-model="row.locked_users"
                                        style="display: block"
                                        @change="changeLockedUser(row)"
                                    ></el-switch>
                                </td>
    
                                <td class="text-center">
                                    <el-switch
                                        v-model="row.locked_create_establishments"
                                        style="display: block"
                                        @change="changeLockedByColumn(row, 'locked_create_establishments')"
                                    ></el-switch>
                                </td>

                                <td class="text-center">
                                    <el-switch
                                        v-model="row.locked_emission"
                                        style="display: block"
                                        @change="changeLockedEmission(row)"
                                    ></el-switch>
                                </td>
    
                                <td class="text-center">
                                    <el-switch
                                        v-model="row.restrict_sales_limit"
                                        style="display: block"
                                        @change="changeLockedByColumn(row, 'restrict_sales_limit')"
                                    ></el-switch>
                                </td>
    
                                <td class="text-right">
                                    <el-dropdown trigger="click">
                                        <el-button>
                                            <i class="fas fa-ellipsis-v"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <template v-if="!row.locked">
                                                <el-dropdown-item
                                                    @click.native.prevent="clickSecretLogin(row.id)"
                                                >
                                                    Acceso Maestro
                                                </el-dropdown-item>
                                                <el-dropdown-item
                                                    @click.native.prevent="clickPassword(row.id)"
                                                >
                                                    Restablecer contraseña
                                                </el-dropdown-item>
                                                <el-dropdown-item
                                                    v-if="deletePermission"
                                                    @click.native.prevent="clickDelete(row)"
                                                >
                                                    Eliminar Cliente
                                                </el-dropdown-item>
                                            </template>
                                            <el-dropdown-item divided
                                                v-if="updateClientsSystem"
                                                @click.native.prevent="clickEdit(row.id)"
                                            >
                                                Editar
                                            </el-dropdown-item>
                                            <el-dropdown-item divided
                                                @click.native.prevent="clickPayments(row.id)"
                                            >
                                                Pagos
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                @click.native.prevent="clickAccountStatus(row.id)"
                                            >
                                                Estado de cuenta
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>

                <el-pagination
                    @current-change="getData"
                    layout="total, prev, pager, next"
                    :total="pagination.total"
                    :current-page.sync="pagination.current_page"
                    :page-size="pagination.per_page"
                >
                </el-pagination>

            </div>
        </div>

        <system-clients-form :recordId="recordId"
                             :EditLimitClient="EditLimitClient"
                             :EditPaymentClientPlan="EditPaymentClientPlan"
                             :showDialog.sync="showDialog"></system-clients-form>

        <client-payments :clientId="recordId"
                         :showDialog.sync="showDialogPayments"></client-payments>

        <account-status :clientId="recordId"
                        :showDialog.sync="showDialogAccountStatus"></account-status>

        <client-delete :record="record"
                        :showDialog.sync="showDialogDelete"></client-delete>

        <lock-or-unlock :showDialog.sync="showDialogLockOrUnlock"></lock-or-unlock>
    </div>
</template>

<script>
import moment from "moment";
import debounce from "lodash/debounce";
// import CompaniesForm from "./form.vue";
import SystemClientsForm from "./form.vue";
//   import CompaniesFormEdit from './form_edit.vue'
import {deletable} from "../../../mixins/deletable";
import {changeable} from "../../../mixins/changeable";
import ChartLine from "./charts/Line";
import ClientPayments from "./partials/payments.vue";
import AccountStatus from "./partials/account_status.vue";
import ClientDelete from "./partials/delete.vue";
import DataLimitNotification from "./partials/DataLimitNotification.vue";
import { data } from "jquery";
import LockOrUnlock from "./partials/LockOrUnlock.vue"

export default {
    mixins: [
        deletable,
        changeable
    ],
    props: [
        'deletePermission',
        'addClientsSystem',
        'updateClientsSystem',
        'discUsed',
        'iUsed',
        'storageSize',
        'version',
        'lockUnlockClientsSystem',
        'EditBillingCycle',
        'EditPaymentCycle',
        'EditLimitClient',
        'EditPaymentClientPlan',
        'showExcel'
    ],
    components: {
        // CompaniesForm,
        ChartLine,
        ClientPayments,
        AccountStatus,
        ClientDelete,
        DataLimitNotification,
        SystemClientsForm,
        LockOrUnlock
    },
    data() {
        return {
            showDialogEdit: false,
            showDialog: false,
            showDialogPayments: false,
            showDialogAccountStatus: false,
            resource: "clients",
            recordId: null,
            records: [],
            text_limit_doc: null,
            text_limit_users: null,
            showDialogDelete: false,
            record: {},

            search: {
                column: 1,
                value: null,
            },

            listOptionSearch: [
                {
                    id: 1,
                    text: "Hostname"
                },
                {
                    id: 2,
                    text: "Nombre"
                },
                {
                    id: 3,
                    text: "RUC"
                },
            ],

            partnerPSE_selected: 0,
            listPartnerPSE: [
                {
                    id: 0,
                    text: "TODOS"
                },
                {
                    id: 1,
                    text: "GIOR"
                },
                {
                    id: 2,
                    text: "QPSE"
                },
            ],

            filterByhNotifications: ['0'],

            listOptionSearchNotifications: [
                {
                    value: '0',
                    label: 'Todos'
                },
                {
                    value: '1',
                    label: 'Comprobantes enviados/por enviar'
                },
                {
                    value: '2',
                    label: 'Comprobantes pendientes de rectificacion'
                },
                {
                    value: '3',
                    label: 'Comprobantes por anular'
                },
                {
                    value: '4',
                    label: 'Comprobantes rechazados',
                    children: [
                        {
                            value: 'all',
                            label: 'Todos'
                        },
                        {
                            value: 'lte_5',
                            label: 'Entre 1 y 5'
                        },
                        {
                            value: 'lte_10',
                            label: 'Entre 6 y 10'
                        },
                        {
                            value: 'gt_10',
                            label: 'Más a 10'
                        }
                    ]
                },
                {
                    value: '5',
                    label: 'Rechazados sin verificar',
                    children: [
                        {
                            value: 'all',
                            label: 'Todos'
                        },
                        {
                            value: 'lte_5',
                            label: 'Entre 1 y 5'
                        },
                        {
                            value: 'lte_10',
                            label: 'Entre 6 y 10'
                        },
                        {
                            value: 'gt_10',
                            label: 'Más a 10'
                        }
                    ]
                },
            ],
            hintsNotifications: {
                lte_5: 'Color verde',
                lte_10: 'Color amarillo',
                gt_10: 'Color rojo'
            },

            orderBy: ['created_at', 'desc'],

            listOptionOrderBy: [
                {
                    value: 'hostname',
                    label: 'Hostname',
                    children: [
                        {
                            value: 'asc',
                            label: 'Ascendente'
                        },
                        {
                            value: 'desc',
                            label: 'Descendente'
                        }
                    ]
                },
                {
                    value: 'name',
                    label: 'Nombre',
                    children: [
                        {
                            value: 'asc',
                            label: 'Ascendente'
                        },
                        {
                            value: 'desc',
                            label: 'Descendente'
                        }
                    ]
                },
                {
                    value: 'number',
                    label: 'RUC',
                    children: [
                        {
                            value: 'asc',
                            label: 'Ascendente'
                        },
                        {
                            value: 'desc',
                            label: 'Descendente'
                        }
                    ]
                },
                {
                    value: 'created_at',
                    label: 'Fecha Creación',
                    children: [
                        {
                            value: 'asc',
                            label: 'Ascendente'
                        },
                        {
                            value: 'desc',
                            label: 'Descendente'
                        }
                    ]
                },
                {
                    value: 'certificate_due',
                    label: 'Fecha vencimiento certificado',
                    children: [
                        {
                            value: 'asc',
                            label: 'Ascendente',
                            children: [
                                {
                                    value: 'red',
                                    label: 'Menos de 1 mes'
                                },
                                {
                                    value: 'yellow',
                                    label: 'Entre 1 y 3 meses'
                                },
                                {
                                    value: 'green',
                                    label: 'Mas de 3 meses'
                                },
                                {
                                    value: 'all',
                                    label: 'Todos'
                                }
                            ]
                        },
                        {
                            value: 'desc',
                            label: 'Descendente',
                            children: [
                                {
                                    value: 'red',
                                    label: 'Menos de 1 mes'
                                },
                                {
                                    value: 'yellow',
                                    label: 'Entre 1 y 3 meses'
                                },
                                {
                                    value: 'green',
                                    label: 'Mas de 3 meses'
                                },
                                {
                                    value: 'all',
                                    label: 'Todos'
                                }
                            ]
                        },
                        {
                            value: 'empty',
                            label: 'Sin fecha vencimiento'
                        }
                    ]
                },
            ],

            use_PSE: false,
            use_OSE: false,
            use_SUNAT: false,

            send_gior_as_ose: false,

            pagination: {},
            loading: false,

            titleCollapse: 'Más filtros',
            showMoreFilters: false,

            morefilters: {
                limit_doc_active: false,
                limit_doc_disabled: false,

                limit_users_active: false,
                limit_users_disabled: false,

                limit_establishment_active: false,
                limit_establishment_disabled: false,

                limit_sales_active: false,
                limit_sales_disabled: false,
            },

            loadingExcel: false,

            statusClient: 0,
            listStatusClient: [
                {
                    id: 0,
                    text: "Todos"
                },
                {
                    id: 1,
                    text: "Bloqueado"
                },
                {
                    id: 2,
                    text: "Activo"
                }
            ],
            cascaderProps: {
                value: 'value',
                label: 'label',
                children: 'children',
                expandTrigger: 'click',
                emitPath: true,   // obtienes ['certificate_due','asc','red'], etc.
                checkStrictly: false,
                multiple: false
            },
            hints: {
                red: 'Color rojo',
                yellow: 'Color amarillo',
                green: 'Color verde'
            },
            created_by: 0,
            listCreated_by: [
                {
                    id: 0,
                    text: "Todos"
                }
            ],
            seller_id: 0,
            listSellers: [
                {
                    id: 0,
                    text: "Todos"
                }
            ],
            configuration_missing_data: false,
            showDialogLockOrUnlock: false,
            disc_used: 0,
            loading_disc: false,
        };
    },
    computed: {
        discPercentage() {
            // df devuelve " 45%", se limpia a número entre 0 y 100
            const value = parseInt(this.disc_used)
            return isNaN(value) ? 0 : Math.min(Math.max(value, 0), 100)
        },
        discRightStyle() {
            const value = Math.min(this.discPercentage, 50)
            return { transform: `rotate(${value / 100 * 360}deg)` }
        },
        discLeftStyle() {
            const value = Math.max(this.discPercentage - 50, 0)
            return { transform: `rotate(${value / 100 * 360}deg)` }
        },
        discText() {
            if (this.loading_disc) return '...'
            return this.disc_used === null ? 'N/D' : `${this.discPercentage}%`
        },
    },
    async created() {
        this.getDiscUsed()
        this.$eventHub.$on("reloadData", () => {
            this.getData();
        });
        await this.getCreated_by()
        await this.getSellers()
        this.getData();

        this.text_limit_doc = "El límite de comprobantes fue superado";
        this.text_limit_users = "El límite de usuarios fue superado";
        this.debouncedGetData = debounce(this.getData, 1000); // 500 ms recomendado
    },

    watch: {
        'search.value'( value ) {
            this.debouncedGetData()
        },

        orderBy(new_value, value) {
            console.log(new_value, value)
            if (new_value !== value) {
                this.getData()
            }
        },

        partnerPSE_selected() {
            this.getData()
        }
    },

    methods: {

        handleChange(value) {
            this.changeClearInput()

            this.filterByhNotifications = ['0']

            this.orderBy = value

            this.getData()
        },

        checkDateDue(param) {
            if (param) {
                const dueDate = moment(param);
    
                const now = moment();
                const diffInDays = dueDate.diff(now, 'days')
    
                if (diffInDays <= 30) {
                    return 'text-danger'
                } else if (diffInDays <= 90) {
                    return 'text-warning'
                } else {
                    return 'text-success'
                }

            }
        },

        partnerPSE(id) {
            if (parseInt(id) === 1) { // GIOR
                return 'GIOR'
            } else if (parseInt(id) === 2) { // QPSE
                return 'QPSE'
            }
        },

        systemClients() {
            this.filterByhNotifications = ['0'];
            this.changeClearInput()
            this.getData()
        },

        clickSearch() {
            console.log("buscando")
            if (this.use_PSE) {
                this.use_PSE = false
            }
            if (this.use_OSE) {
                this.use_OSE = false
            }
            
            this.getData()
        },

        changeNotifications() {
            if (this.use_PSE) {
                this.use_PSE = false;
            }
            if (this.use_OSE) {
                this.use_OSE = false;
            }
            this.getData();  
        },

        filterPSE() {
            this.filterByhNotifications = ['0'];
            this.changeClearInput()
            this.getData();
        },
        filterOSE() {
            this.filterByhNotifications = ['0'];
            this.changeClearInput()
            this.getData();
        },
        filterSUNAT() {
            this.filterByhNotifications = ['0'];
            this.changeClearInput()
            this.getData();
        },

        changeClearInput() {
            this.search.value = '';
        },

        changeLockedTenant(row) {
            this.$http
                .post(`${this.resource}/locked_tenant`, row)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        this.$eventHub.$emit("reloadData");
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message);
                    } else {
                        console.log(error.response);
                        if (error.response) {
                            let message = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(message)
                        }
                    }
                })
                .then(() => {
                });
        },

        changeLockedUser(row) {
            this.$http
                .post(`${this.resource}/locked_user`, row)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        this.$eventHub.$emit("reloadData");
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message);
                    } else {
                        console.log(error.response);
                        if (error.response) {
                            let message = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(message)
                        }
                    }
                })
                .then(() => {
                });
        },
        changeLockedByColumn(row, column)
        {
            const params = { ...row }
            params.column = column

            this.$http
                .post(`${this.resource}/locked-by-column`, params)
                .then(response => {

                    if (response.data.success)
                    {
                        this.$message.success(response.data.message)
                        this.$eventHub.$emit("reloadData")
                    }
                    else
                    {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 500)
                    {
                        this.$message.error(error.response.data.message)
                    }
                    else
                    {
                        console.log(error.response)
                        if (error.response) {
                            let message = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(message)
                        }
                    }
                })
                .then(() => {
                })
        },
        setStartBillingCycle(event, id) {
            this.$http
                .post(`${this.resource}/set_billing_cycle`, {
                    id: id,
                    start_billing_cycle: event
                })
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message);
                    } else {
                        console.log(error.response);
                        if (error.response) {
                            let message = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(message)
                        }
                    }
                })
                .then(() => {
                    this.$eventHub.$emit("reloadData");
                });
        },

        setStartPaymentCycle(event, id) {
            this.$http
                .post(`${this.resource}/set_payment_cycle`, {
                    id: id,
                    start_payment_cycle: event
                })
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message);
                    } else {
                        console.log(error.response);
                        if (error.response) {
                            let message = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(message)
                        }
                    }
                })
                .then(() => {
                    this.$eventHub.$emit("reloadData");
                });
        },
        changeLockedEmission(row) {
            this.$http
                .post(`${this.resource}/locked_emission`, row)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message);
                        this.$eventHub.$emit("reloadData");
                    } else {
                        this.$message.error(response.data.message);
                    }
                })
                .catch(error => {
                    if (error.response.status === 500) {
                        this.$message.error(error.response.data.message);
                    } else {
                        console.log(error.response);
                        if (error.response) {
                            let message = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(message)
                        }
                    }
                })
                .then(() => {
                });
        },
        getData() {
            this.loading = true
            this.$http.get(`/${this.resource}/records`, {
                params: {
                    page: this.pagination.current_page,
                    column: this.search.column,
                    value: this.search.value,
                    filterByhNotifications: this.filterByhNotifications,
                    use_OSE: this.use_OSE,
                    use_SUNAT: this.use_SUNAT,
                    use_PSE: this.use_PSE,
                    orderBy: this.orderBy,

                    partnerPSE: this.partnerPSE_selected,

                    send_gior_as_ose: this.send_gior_as_ose,

                    morefilters: JSON.stringify(this.morefilters),
                    statusClient: this.statusClient,
                    created_by: this.created_by,
                    configuration_missing_data: this.configuration_missing_data,
                    seller_id: this.seller_id
                }
            })
            .then(response => {
                this.records = response.data.data;
                this.pagination = response.data.meta;
                this.pagination.per_page = parseInt(
                    response.data.meta.per_page
                );
            })
            .catch(error => {
                let message = error.response.data.message || 'Error al cargar los registros'
                this.$message.error(message)
            })
            .finally(() => {
                this.loading = false
            })
        },
        clickCreate(recordId = null) {
            this.recordId = recordId;
            this.showDialog = true;
        },
        clickPayments(recordId = null) {
            this.recordId = recordId;
            this.showDialogPayments = true;
        },
        clickAccountStatus(recordId = null) {
            this.recordId = recordId;
            this.showDialogAccountStatus = true;
        },
        clickPassword(id) {
            this.change(`/${this.resource}/password/${id}`);
        },
        clickDelete(record) {

            this.record = record
            this.showDialogDelete = true
            // this.destroy(`/${this.resource}/${id}`).then(() =>
            //     this.$eventHub.$emit("reloadData")
            // );
        },
        clickEdit(recordId) {
            this.recordId = recordId;
            this.showDialog = true;
        },

        sendGior() {
            this.getData()
        },

        changeLockedEmissionMassive() {
            
                this.$confirm('¿Está seguro de querer activar el límite de doc. masivamente?', 'Warning', {
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    type: 'warning'
                }).then(() => {

                    this.$http.post(`${this.resource}/locked_emission_massive`)
                        .then(response => {
                            if (response.data.success) {
                                this.$message.success(response.data.message)
                                this.$eventHub.$emit("reloadData")
                            } else {
                                this.$message.error(response.data.message)
                            }
                        }).catch(error => {
                            if (error.response.status === 500) {
                                this.$message.error(error.response.data.message)
                            } else {
                                console.log(error.response)
                                let message = error.response.data.message || 'Error al realizar la operación'
                                this.$message.error(message)
                            }
                        })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Operación cancelada'
                    })
                })
            
        },

        changeLockedUserMassive() {
            
            this.$confirm('¿Está seguro de querer activar el límite de usuarios masivamente?', 'Warning', {
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                type: 'warning'
            }).then(() => {

                this.$http.post(`${this.resource}/locked_user_massive`)
                    .then(response => {
                        if (response.data.success) {
                            this.$message.success(response.data.message)
                            this.$eventHub.$emit("reloadData")
                        } else {
                            this.$message.error(response.data.message)
                        }
                    }).catch(error => {
                        if (error.response.status === 500) {
                            this.$message.error(error.response.data.message)
                        } else {
                            console.log(error.response)
                            let message = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(message)
                        }
                    })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Operación cancelada'
                })
            })
            
        },
        changeLockedEstablishmentsMassive() {
            
            this.$confirm('¿Está seguro de querer activar el límite de establecimientos masivamente?', 'Warning', {
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                type: 'warning'
            }).then(() => {

                this.$http.post(`${this.resource}/locked_establishments_massive`)
                    .then(response => {
                        if (response.data.success) {
                            this.$message.success(response.data.message)
                            this.$eventHub.$emit("reloadData")
                        } else {
                            this.$message.error(response.data.message)
                        }
                    }).catch(error => {
                        if (error.response.status === 500) {
                            this.$message.error(error.response.data.message)
                        } else {
                            console.log(error.response)
                            let message = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(message)
                        }
                    })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Operación cancelada'
                })
            })
            
        },
        changeLockedSalesMassive() {
            
            this.$confirm('¿Está seguro de querer activar el límite de ventas masivamente?', 'Warning', {
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                type: 'warning'
            }).then(() => {

                this.$http.post(`${this.resource}/locked_sales_massive`)
                    .then(response => {
                        if (response.data.success) {
                            this.$message.success(response.data.message)
                            this.$eventHub.$emit("reloadData")
                        } else {
                            this.$message.error(response.data.message)
                        }
                    }).catch(error => {
                        if (error.response.status === 500) {
                            this.$message.error(error.response.data.message)
                        } else {
                            console.log(error.response)
                            let message = error.response.data.message || 'Error al realizar la operación'
                            this.$message.error(message)
                        }
                    })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Operación cancelada'
                })
            })
            
        },

        changeShowMoreFilters() {
            this.showMoreFilters = !this.showMoreFilters
        },

        resetMoreFilter() {
            this.morefilters = {
                limit_doc_active: false,
                limit_doc_disabled: false,

                limit_users_active: false,
                limit_users_disabled: false,

                limit_establishment_active: false,
                limit_establishment_disabled: false,

                limit_sales_active: false,
                limit_sales_disabled: false,
            }
            this.getData()
        },

        changeLimitDocumentsActive() {

            if (this.morefilters.limit_doc_active) {
                this.morefilters.limit_doc_active = true
                this.morefilters.limit_doc_disabled = false
            }
            
            this.getData()
        },

        changeLimitDocumentsDisabled() {

            if (this.morefilters.limit_doc_disabled) {
                this.morefilters.limit_doc_active = false
                this.morefilters.limit_doc_disabled = true
            }
            
            this.getData()
        },

        changeLimitUsersActive() {
            if (this.morefilters.limit_users_active) {
                this.morefilters.limit_users_active = true
                this.morefilters.limit_users_disabled = false
            }
            this.getData()
        },

        changeLimitUsersDisabled() {
            if (this.morefilters.limit_users_disabled) {
                this.morefilters.limit_users_active = false
                this.morefilters.limit_users_disabled = true
            }
            this.getData()
        },

        changeLimitEstablishmentActive() {
            if (this.morefilters.limit_establishment_active) {
                this.morefilters.limit_establishment_active = true
                this.morefilters.limit_establishment_disabled = false
            }
            this.getData()
        },

        changeLimitEstablishmentDisabled() {
            if (this.morefilters.limit_establishment_disabled) {
                this.morefilters.limit_establishment_active = false
                this.morefilters.limit_establishment_disabled = true
            }
            this.getData()
        },

        changeLimitSalesActive() {
            if (this.morefilters.limit_sales_active) {
                this.morefilters.limit_sales_disabled = false
                this.morefilters.limit_sales_active = true
            }
            this.getData()
        },

        changeLimitSalesDisabled() {
            if (this.morefilters.limit_sales_disabled) {
                this.morefilters.limit_sales_active = false
                this.morefilters.limit_sales_disabled = true
            }
            this.getData()
        },

        async exportClientExcel() {
            // window.open(`/clients/export/excel`, '_blank');
            try {
                this.loadingExcel = true
                const response = await this.$http.post(`/clients_system/export/excel`)
                const { data } = response
                if (data.success) {
                    this.$message.success(data.message)
                } else {
                    this.$message.error(data.message)
                }
            } catch (error) {
                let message = error.response.data.message || 'Error al exportar'
                this.$message.error(message)
            } finally {
                this.loadingExcel = false
            }
        },

        typeNotificationDocumentReject(qty) {
            if (qty === 0) {
                return 'primary'
            } else if (qty > 0 && qty <= 5) {
                return 'success'
            } else if (qty > 5 && qty <= 10) {
                return 'warning'
            } else {
                return 'danger'
            }
        },

        messageInfo(type, include_sale_notes) {
            let message = 'Cantidad de comprobantes'
            if (type === 'amount') {
                message = 'Monto de comprobantes'
            }
            if (include_sale_notes) {
                message += ' + nota de venta'
            }
            return message
        },

        async clickSecretLogin(clientId) {
            try {
                const { data } = await this.$http.post(`/secret-login`, {
                    client_id: clientId
                })
                
                if (data.success) {
                    this.$message.success(data.message)
                    setTimeout(() => {
                        window.open(`${data.url}/${clientId}`, '_blank')
                    }, 1000)
                } else {
                    this.$message.error(data.message)
                }
            } catch (error) {
                let message = error.response.data.message || 'Error al realizar la operación'
                this.$message.error(message)
            }
        },

        async getCreated_by() {
            try {
                const { data } = await this.$http.get(`/${this.resource}/created_by`)
                
                let listData = data.map(item => {
                    return {
                        id: item.id,
                        text: item.name
                    }
                })
                this.listCreated_by.push(...listData)
            } catch (error) {
                let message = error.response.data.message || 'Error al realizar la operación'
                this.$message.error(message)
            }
        },

        async getSellers() {
            try {
                const { data } = await this.$http.get(`/${this.resource}/sellers`)
                let listData = data.map(item => {
                    return {
                        id: item.id,
                        text: item.name
                    }
                })
                this.listSellers.push(...listData)
            } catch (error) {
                let message = error.response.data.message || 'Error al realizar la operación'
                this.$message.error(message)
            }
        },
        getDiscUsed() {
            this.loading_disc = true
            this.$http.get(`/systems/statistics`)
                .then(response => {
                    this.disc_used = response.data.disc_used
                })
                .catch(() => {
                    this.disc_used = null
                })
                .finally(() => this.loading_disc = false)
        },

    }
};
</script>


<style>
    .custom-checkbox {
        pointer-events: none;
        cursor: not-allowed;
    }
    .cascader-notifications .el-cascader-menu__wrap {
        height: auto;
    }
</style>


// WEBPACK FOOTER //
// resources/js/views/system/clients/systems.vue